import React from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogClose, DialogContent, DialogTitle } from '@/components/ui/dialog';

export const DishImagePreviewDialog = ({ open, onOpenChange, imageUrl, title, categoryName }) => {
  if (!imageUrl) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl border-0 bg-transparent p-0 shadow-none [&>button]:hidden">
        <div className="relative overflow-hidden rounded-[30px] border border-white/10 bg-black/90 shadow-2xl">
          <DialogClose className="absolute right-4 top-4 z-20 inline-flex h-11 w-11 items-center justify-center rounded-full bg-red-500 text-white shadow-lg transition-colors hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-white/80 focus:ring-offset-2 focus:ring-offset-black">
            <X className="h-5 w-5" />
            <span className="sr-only">Chiudi anteprima</span>
          </DialogClose>

          <div className="relative">
            <img
              src={imageUrl}
              alt={title}
              className="w-full max-h-[78vh] object-contain bg-black"
            />

            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/55 to-transparent px-5 py-6 sm:px-7 sm:py-8">
              {categoryName ? (
                <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.28em] text-white/70">
                  {categoryName}
                </p>
              ) : null}

              <DialogTitle className="text-left text-xl font-bold text-white sm:text-3xl">
                {title}
              </DialogTitle>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
